module.exports = Promise.all([__parcel__import__("5L8PD"), __parcel__import__("kplFQ")]).then(() => parcelRequire('4qady'));